let timelineJson = require('../data/timeline-details.json');
let datesJson = require('../data/timeline-dates.json');


document.addEventListener("DOMContentLoaded", function(event) { 
    generateTimelineData();
});

async function generateTimelineData() {

    let no = [0,0,0,0,0];

    timelineJson.forEach(day => {

        let container = document.querySelector("#day-" + day.dayNum);
        let currNo = no[parseInt(day.dayNum)];
        no[parseInt(day.dayNum)] = currNo ? currNo + 1 : 1;
    
        container.innerHTML += `
        <div class="col-12 col-md-6 col-lg-4 d-flex justify-content-center">
            <div class="single-timeline-content d-flex justify-content-center" data-aos="zoom-in" data-aos-delay="${100*currNo}">
                <div class="timeline-icon"><i class="fa fa-${day.icon}" aria-hidden="true"></i></div>
                <div class="timeline-text">
                    <h6>${day.title}<p class="text-muted py-2">${day.time}</p></h6>
                    <p>${day.description}</p>
                </div>
            </div>
        </div>
        `
    })
}